
import { useEffect, useState, useRef } from 'react';
import hamburgerMenu from "../../../assets/menuHamburger.svg";
import logoIcon from "../../../assets/pr-logo1.svg";
import closeIcon from "../../../assets/closeIcon.svg";
import { featureSubmenu } from '../HomePageData';
import arrow from "../../../assets/arrow.svg"
import NavItem from './NavLink';
import FeatureSubmenuLinkItem from './FeatureSubmenuLinkItem';
import { motion } from 'framer-motion';
import { Link } from 'react-router-dom';
import { useStore } from '../../../store/store';
import Button from "../../ui/Button"
import backArrow from "../../../assets/backArrow.svg"

const Navbar = () => {
  const [isOpen, setIsOpen] = useState(false);
  // const [clickedItem, setClickedItem] = useState(null);
  const submenuRef = useRef(null);
  const isVisible = useStore((state) => state.isVisible)
  const clickedItem = useStore((state) => state.clickedItem)
  const setClickedItem = useStore((state) => state.setClickedItem)



  const handleItemClick = (index) => {
    setClickedItem(index);
  };


  useEffect(() => {
    const handleResize = () => {
      setIsOpen(window.innerWidth > 768);
    };

    handleResize();

    window.addEventListener('resize', handleResize);

    return () => {
      window.removeEventListener('resize', handleResize);

    };
  }, []);



  useEffect(() => {
    const handleClickOutside = (event) => {
      if (submenuRef.current && !submenuRef.current.contains(event.target)) {
        setClickedItem(null);
      }
    };

    window.addEventListener('click', handleClickOutside);

    return () => {
      window.removeEventListener('click', handleClickOutside);
    };
  }, [setClickedItem]);
  return (
    < motion.nav

      transition={{
        duration: 0.7,
      }}

      className={`md:flex pt-10 -top-4 ${isVisible ? "md:bg-black md:-top-6" : ""} w-[96%]  sm:w-[98%] fixed mx-auto  left-0 right-0  md:pt-16  md:justify-between md:gap-6 md:items-center z-[90000]  `}>
      <div className='flex justify-between items-center border-[#3F3F48] border-[1px] md:hidden bg-[#0F0F10] md:text-center md:w-1/2 mx-auto mt-6 px-10 py-6 rounded-full'>
        <Link to="/"><img className='md:hidden' src={logoIcon} alt="playroom logo" /></Link>
        {!isOpen && <img onClick={() => setIsOpen(true)} className='md:hidden h-[13px] w-[20px]' src={hamburgerMenu} alt="hamburger menu" />}
        {isOpen && <img onClick={() => setIsOpen(false)} className='md:hidden h-[30px] w-[20px]' src={closeIcon} alt="close icon" />}
      </div>
      {isOpen && (
        <motion.ul
          ref={submenuRef}
          initial={{ opacity: 0, y: -10 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.5 }}
          className='flex justify-between  py-4 md:py-4 flex-col md:items-center md:w-[90%]  lg:w-auto  lg:mx-auto cursor-pointer gap-6 md:flex md:flex-row md:gap-0 text-[1.4rem] bg-[#0F0F10] mt-6 md:mt-0 p-6 md:rounded-full md:justify-between mx-auto rounded-[18px] border-[0.67px] border-primaryBorderColor px-12'
        >
          <li>
            <Link to="/"><img className='hidden md:block mr-10 ' src={logoIcon} alt="playroom logo" /></Link>
          </li>

          <li
            onMouseEnter={() => (window.innerWidth > 768) && handleItemClick(3)}
            onClick={(e) => {console.log(e.target.className);  e.target.className.includes('backToFirstNavMenu') ?  handleItemClick(2):handleItemClick(3) }}
            className={`rounded-full  my-3 md:my-0 relative hover:text-[#efefefc8] border-[1px] border-lightBlack transition-colors duration-150 md:p-2 md:py-4 md:px-6 lg:py-5 lg:px-11 ${clickedItem === 3 ? 'md:bg-white md:text-black' : ''} md:hover:text-black`}
          >
            <span className={` items-center flex justify-between w-full ${clickedItem === 3 ? "hidden md:inline-flex":"block"}`} >
              <span className=''>Features</span>
              <svg className='relative left-3 lg:left-5 -rotate-90 md:rotate-0  block' width="9" height="6" viewBox="0 0 9 6" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path d="M0.5 0.903076L4.25 4.65308L8 0.903076" stroke={`${clickedItem === 3 ? 'black' : 'white'}`} />
              </svg>
            </span>

            {clickedItem === 3 && (
              <motion.div
              initial={{ opacity: 0, y: -10 }}
              animate={{ opacity: 1, y: 0 }}
              transition={{ duration: 0.5 }}
                className='featureMenu md:z-20  md:top-20 md:absolute  md:w-[600px] md:min-h-[200px] md:rounded-3xl md:right-[-30rem] lg:right-[-20rem]  md:border-[#3F3F48] md:border-[0.67px] md:top-[6.5rem]  md:p-8 md:grid md:grid-cols-2 md:items-center md:justify-center md:gap-8 lg:p-10'
              >

                <Button className="m-0 backToFirstNavMenu flex items-center gap-2  bg-[#ffff] font-bold hover:bg-white px-12 py-4 relative bottom-10  md:hidden"> 
                <img src={backArrow}  className='rotate-90 backToFirstNavMenu relative right-8' alt="back arrow" />
              <span className='backToFirstNavMenu'>Back</span></Button>
                {featureSubmenu.map(({ title, description, icon, onHoverIcon, href }, index) => (
                  <FeatureSubmenuLinkItem
                    key={index}
                    title={title}
                    description={description}
                    icon={icon}
                    onHoverIcon={onHoverIcon}
                    href={href}
                  />
                ))}

              </motion.div>
            )}
          </li>
   
          <NavItem  itemIndex={1} handleItemClick={handleItemClick} clickedItem={clickedItem}>
            <Link target='_blank' to="https://docs.joinplayroom.com">Documentation</Link>
          </NavItem>
          
          <NavItem itemIndex={2} handleItemClick={handleItemClick} clickedItem={clickedItem}>
            <Link to="/pricing">Pricing</Link>
          </NavItem>

          <NavItem itemIndex={4} handleItemClick={handleItemClick} clickedItem={clickedItem} className={`link  gap-2 hover:link ${clickedItem === 3 ? "hidden md:block":"block"}`}>             
            <Link target='_blank' to="https://dev.joinplayroom.com" className="flex items-center gap-2">
              <span>Dev</span>
              <img className='md:relative md:top-[2px]' src={arrow} alt='arrow icon' />              
            </Link>
          </NavItem>
        
        
    
        </motion.ul>
      )}
    </motion.nav>
  );
};

export default Navbar;